<template>
  <table-component-buefy
    v-if="mixin.loaded"
    :content="logs"
    :headings="table_headings"
    :item_keys="table_keys"
    :display_spec="customerLogSpecs"
    :total_items="mixin.total_items"
    :hide_table_search="true"
    :default_search="String(customerId)"
    :pagination_callback="mixin.loadItems">
  </table-component-buefy>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import { customerLogSpecs } from '@/display_context/display_context'
  import { loadItemsMixin } from '@/mixins/mixins'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'

  export default {
    name: 'customer-log-view',
    mixins: [loadItemsMixin],
    components: {
      TableComponentBuefy
    },
    data () {
      return {
        table_headings: ['Timestamp', 'Email sent'],
        table_keys: ['timestamp', 'content'],
        customerLogSpecs: customerLogSpecs,
        mixin: {
          actionMethod: this.getCustomerLogs,
          actionParams: { customerId: this.customerId }
        }
      }
    },
    props: {
      customerId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        logs: state => state.customerModule.customerLogs
      })
    },
    methods: {
      ...mapActions([
        'getCustomerLogs'
      ])
    }
  }
</script>
